import { makeStyles } from "@rbx/ui";

const useAccessDeniedErrorStyles = makeStyles()(() => ({
  background: {
    marginTop: 68,
    marginBottom: 68,
  },
}));

export default useAccessDeniedErrorStyles;
